<script setup>
// Subtle live/offline indicator: a small dot + label, instead of a heavy filled
// badge. Used across the backup/ingest UI so status is clear but not loud.
defineProps({
	alive: { type: Boolean, default: false },
	liveLabel: { type: String, default: 'Live' },
	offlineLabel: { type: String, default: 'Offline' },
})
</script>

<template>
	<span class="inline-flex items-center gap-1.5 text-tiny font-medium"
		:class="alive ? 'text-success' : 'text-surface-6'">
		<span class="inline-block w-1.5 h-1.5 rounded-full shrink-0" :class="alive ? 'bg-success' : 'bg-surface-6'" />
		{{ alive ? liveLabel : offlineLabel }}
	</span>
</template>
